module.exports = __webpack_public_path__ + "img/Avatar-59.03284b17.svg";